import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { strongPassword } from 'shared/forms/validators';

import renderInputField from 'shared/forms/RenderInputField';
import Button from 'shared/components/Button';
import LinkedInButton from 'shared/components/LinkedInButton';

import { openModal } from 'shared/components/Modals/reducer';
import { withModal, FullScreenModal } from 'shared/components/Modals';
import Errors from 'shared/forms/Errors';
import { MODALS } from 'global-constants';

import { requestLogin } from './ducks';

import classnames from 'classnames';
import styles from './styles.module.scss';

const FORM_NAME = 'loginForm';

class LoginModal extends React.Component {
  submit = data => {
    this.props.requestLogin(FORM_NAME, data, this.props.closeModalExtraActions);
  };

  redirectToSignUp = () => {
    this.props.closeModal();
    this.props.openModal({ modalName: MODALS.SIGNUP });
  };

  redirectToForgotPassword = () => {
    this.props.openModal({ modalName: MODALS.FORGOT_PASSWORD });
    this.props.closeModal();
  };

  closeModal = () => {
    const { clearQueryParams } = this.props.data;
    this.props.closeModal();

    !_.isNil(clearQueryParams) && clearQueryParams();
  };

  render() {
    const { handleSubmit, submitting, error, invalid } = this.props;

    return (
      <FullScreenModal closeModal={this.closeModal}>
        <div className={styles.loginFormWrapper}>
          <div className={styles.loginFormContainer}>
            <div className={styles.title}>Sign in to Unissu</div>
            <LinkedInButton name="Sign in with LinkedIn" />
            <div className={styles.divider}>
              <div className={styles.orBox}>or</div>
            </div>
            {!_.isEmpty(error) && <Errors errors={error} />}
            <form
              className={classnames(styles.form, 'form')}
              onSubmit={handleSubmit(this.submit)}>
              <div className="form-group">
                <label className="form-label">Email address*</label>
                <Field
                  name="email"
                  component={renderInputField}
                  type="email"
                  required
                  placeholder="Enter your email address"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Password*</label>
                <Field
                  name="password"
                  component={renderInputField}
                  type="password"
                  placeholder="Enter your password"
                  disabled={submitting}
                  validate={strongPassword}
                />
              </div>
              <Button
                className={styles.signinBtn}
                color="brand-green"
                type="submit"
                disabled={invalid}>
                Sign In
              </Button>
              <div className={styles.signupText}>
                <div
                  className={classnames(styles.link, styles.forgotPassLink)}
                  onClick={this.redirectToForgotPassword}>
                  Forgot Password?
                </div>
                <div>
                  Don't have an account?{' '}
                  <span className={styles.link} onClick={this.redirectToSignUp}>
                    Sign up
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </FullScreenModal>
    );
  }
}

LoginModal = reduxForm({
  form: FORM_NAME
})(LoginModal);

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = {
  requestLogin,
  openModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModal(MODALS.LOGIN)(LoginModal));
